import {Utils} from "./Utils";

export class UrlHashNavigation {
    private readonly items: NodeListOf<HTMLElement>;

    constructor(list: Element) {
        this.items = list.childNodes as NodeListOf<HTMLElement>;
        this.init();
    }

    switch() {
        this.items.forEach((item) => {
            const link = item.querySelector(`a`);
            const href = link ? link.getAttribute(`href`) : ``;
            if (link) {
                Utils.getUrlHash() === href
                    ? link.classList.add(`is-active`)
                    : link.classList.remove(`is-active`);
            }
        });
    }

    init(): void {
        if (Utils.getUrlHash()) this.switch();
        window.addEventListener('hashchange', () => this.switch());
    }
}